import i18next from 'i18next';
import en from './i18n/en';
import ptBr from './i18n/pt-br';

i18next.addResourceBundle('en', 'services/alerts', en);
i18next.addResourceBundle('pt-br', 'services/alerts', ptBr);

export { default as cancelarAlert } from './cancelarAlert';
export { default as confirmarAlert } from './confirmarAlert';
export { default as confirmarCheckboxAlert } from './confirmarCheckboxAlert';
export { default as errorAlert } from './errorAlert';
export { default as excluirAlert } from './excluirAlert';
export { default as simpleAlert } from './simpleAlert';
